import { createContext, useContext, useState, ReactNode } from "react";

type RepoContextType = {
  selectedRepo: string;
  setSelectedRepo: (repo: string) => void;
  selectedVersion: string;
  setSelectedVersion: (version: string) => void;
};

const RepoContext = createContext<RepoContextType | undefined>(undefined);

export const RepoProvider = ({ children }: { children: ReactNode }) => {
  const [selectedRepo, setSelectedRepo] = useState("");
  const [selectedVersion, setSelectedVersion] = useState("");

  return (
    <RepoContext.Provider
      value={{
        selectedRepo,
        setSelectedRepo,
        selectedVersion,
        setSelectedVersion,
      }}
    >
      {children}
    </RepoContext.Provider>
  );
};

export const useRepoContext = () => {
  const context = useContext(RepoContext);
  if (!context) {
    throw new Error("useRepoContext must be used within a RepoProvider");
  }
  return context;
};
